import { createAsyncThunk } from "@reduxjs/toolkit";
import { PayrollService } from "../../services";
import { createCRUDThunks, handleAsyncThunkError } from "../../shared/helpers";
import {
  AxiosParams,
  PayrollRequest,
  PayrollResponse,
  PayrollFormValues,
} from "../../shared/types";

const service = new PayrollService();

const basicThunks = createCRUDThunks<
  PayrollRequest,
  PayrollResponse,
  PayrollFormValues
>({
  service,
  resourceName: "payrolls",
});

const bulkSave = createAsyncThunk(
  `payrolls/bulkSave`,
  async (payrolls: PayrollRequest[], { rejectWithValue }) => {
    try {
      const data = await service.bulkSave(payrolls);
      return data.data;
    } catch (error) {
      return handleAsyncThunkError(error, rejectWithValue);
    }
  }
);

const getPayrollsByPeriod = createAsyncThunk(
  `payrolls/getPayrollsByPeriod`,
  async (
    { startDate, endDate }: { startDate: string; endDate: string },
    { rejectWithValue }
  ) => {
    try {
      const data = await service.getPayrollsByPeriod(startDate, endDate);
      return data.data;
    } catch (error) {
      return handleAsyncThunkError(error, rejectWithValue);
    }
  }
);

const getPayrollsByCollaborator = createAsyncThunk(
  `payrolls/getPayrollsByCollaborator`,
  async (
    {
      collaboratorId,
      params,
    }: { collaboratorId: string; params?: AxiosParams },
    { rejectWithValue }
  ) => {
    try {
      const data = await service.getPayrollsByCollaborator(
        collaboratorId,
        params
      );
      return data.data;
    } catch (error) {
      return handleAsyncThunkError(error, rejectWithValue);
    }
  }
);

const approvePayroll = createAsyncThunk(
  `payrolls/approvePayroll`,
  async (payrollId: string, { rejectWithValue }) => {
    try {
      const data = await service.approvePayroll(payrollId);
      return data;
    } catch (error) {
      return handleAsyncThunkError(error, rejectWithValue);
    }
  }
);

const processPayment = createAsyncThunk(
  `payrolls/processPayment`,
  async (payrollId: string, { rejectWithValue }) => {
    try {
      const data = await service.processPayment(payrollId);
      return data;
    } catch (error) {
      return handleAsyncThunkError(error, rejectWithValue);
    }
  }
);

export const PayrollThunks = {
  ...basicThunks,
  bulkSave,
  getPayrollsByPeriod,
  getPayrollsByCollaborator,
  approvePayroll,
  processPayment,
};
